var _rect, _rect2, _rect3, _rect4, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 219,
    viewBox: "0 0 194 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 23,
    width: 19,
    height: 20,
    rx: 5,
    fill: "#111949"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 46,
    width: 19,
    height: 20,
    rx: 5,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 69,
    width: 19,
    height: 20,
    rx: 5,
    fill: "#2365D2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.5,
    y: 2.5,
    width: 145,
    height: 214,
    rx: 9.5,
    fill: "#111949",
    stroke: "black",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167 38.1422V23C167 16.3726 161.627 11 155 11H54.4072C47.7797 11 42.4072 16.3726 42.4072 23V196C42.4072 202.627 47.7798 208 54.4072 208H155C161.627 208 167 202.627 167 196V91.1133",
    stroke: "#2365D2",
    strokeWidth: 11
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4072 60.1422H18C11.3726 60.1422 6 65.5148 6 72.1422V75.7222C6 82.3496 11.3726 87.7222 18 87.7222H34.4072M34.4072 115.302H6M34.4072 142.444H18C11.3726 142.444 6 147.817 6 154.444V157.587C6 164.214 11.3726 169.587 18 169.587H34.4072M34.4072 197.167H6M34.4072 33H6",
    stroke: "#111949",
    strokeWidth: 11
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.44362cc000fb4323f9e563f4c5020097.svg";
export { ForwardRef as ReactComponent };